"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7909],{

/***/ 7909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* reexport */ RelatedStoriesFieldsFragment; },
  "yS": function() { return /* reexport */ StoryActions; },
  "I9": function() { return /* reexport */ StoryAuthor/* default */.ZP; },
  "i1": function() { return /* reexport */ StoryAwards; },
  "Ey": function() { return /* reexport */ src_StoryCard; },
  "RP": function() { return /* reexport */ fragments_StoryCardFieldsFragment; },
  "f6": function() { return /* reexport */ StoryCoauthors; },
  "Dv": function() { return /* reexport */ StoryCollaborators; },
  "CK": function() { return /* reexport */ fragments_StoryFieldsFragment; },
  "cL": function() { return /* reexport */ StoryGallery; },
  "ew": function() { return /* reexport */ StoryGovernments; },
  "WJ": function() { return /* reexport */ StoryHeader; },
  "HE": function() { return /* reexport */ StoryHighlights; },
  "th": function() { return /* reexport */ StoryNewsworthy; },
  "lm": function() { return /* reexport */ StoryProducts; },
  "fp": function() { return /* reexport */ StoryRelatedStories; },
  "FT": function() { return /* reexport */ StoryRelatedStoriesSmall; },
  "gd": function() { return /* reexport */ StoryResources; }
});

// UNUSED EXPORTS: StoryNewsworthyItem, StorySummary

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/tooltip/Tooltip.tsx + 1 modules
var Tooltip = __webpack_require__(25568);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(87169);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/StoryPodcastIcon.tsx






function StoryPodcastIcon(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SvgBox */.$C, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "16px",
        height: "20px",
        viewBox: "0 0 16 20"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.99995 9.42157C9.10595 9.42157 10.0026 8.57707 10.0026 7.53528C10.0026 6.49353 9.106 5.64899 7.99995 5.64899C6.89391 5.64899 5.99731 6.49353 5.99731 7.53528C5.99731 8.57707 6.89396 9.42157 7.99995 9.42157ZM7.99995 2.82192C5.23633 2.82192 2.996 4.93215 2.996 7.53523C2.996 8.80116 3.52599 9.95041 4.38817 10.7972C4.63486 10.4232 4.97551 10.0669 5.44522 9.79368C4.85656 9.20317 4.49535 8.40913 4.49535 7.53523C4.49535 5.7121 6.06441 4.2342 7.99995 4.2342C9.93555 4.2342 11.5045 5.7121 11.5045 7.53523C11.5045 8.41106 11.1418 9.20658 10.5509 9.79749C11.0198 10.0716 11.3595 10.4288 11.6054 10.8034C12.4713 9.95594 13.004 8.80427 13.004 7.53523C13.004 4.9322 10.7636 2.82192 7.99995 2.82192ZM7.99995 0C3.58167 0 0 3.37368 0 7.53528C0 10.2511 1.52565 12.6311 3.81351 13.9572C3.76797 13.6307 3.7388 13.2803 3.7388 12.9173C3.7388 12.9173 3.73659 12.6367 3.8167 12.2315C2.3952 11.1069 1.49141 9.42063 1.49141 7.53528C1.49141 4.14948 4.40536 1.40481 8 1.40481C11.5946 1.40481 14.5086 4.14948 14.5086 7.53528C14.5086 9.42463 13.601 11.1141 12.1743 12.2387C12.2528 12.64 12.2507 12.9172 12.2507 12.9172C12.2507 13.2827 12.2213 13.6355 12.1752 13.9638C14.4694 12.639 16 10.2556 16 7.53528C15.9999 3.37363 12.4182 0 7.99995 0ZM7.99995 10.3647C6.47921 10.3647 5.24631 11.526 5.24631 12.9584C5.24631 14.3908 6.47916 19.0769 7.99995 19.0769C9.52075 19.0769 10.7536 14.3908 10.7536 12.9584C10.7536 11.526 9.52075 10.3647 7.99995 10.3647Z",
            fill: "currentColor"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/StoryCard.tsx









var IMediaType;
(function(IMediaType) {
    IMediaType["Image"] = "IMAGE";
    IMediaType["Video"] = "VIDEO";
    IMediaType["Youtube"] = "YOUTUBE";
})(IMediaType || (IMediaType = {}));
var StoryCard = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var story = _param.story, placeholderImageSrc = _param.placeholderImageSrc, translationLinkWrap = _param.translationLinkWrap, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "story",
        "placeholderImageSrc",
        "translationLinkWrap"
    ]);
    var image = (story.medias || []).find(function(media) {
        return media.type === IMediaType.Image;
    });
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        _hover: {
            shadow: "lg"
        },
        transition: "0.2s all",
        as: "a",
        bg: "white",
        border: "solid 1px",
        borderColor: "gray.100",
        borderRadius: "md",
        paddingX: [
            6,
            6,
            8
        ],
        paddingY: 6,
        direction: "column",
        cursor: "pointer",
        ref: ref,
        position: "relative"
    }, props), {
        children: [
            story.hasPodcast && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                label: intl.formatMessage({
                    defaultMessage: "Podcast",
                    id: "uNMm97"
                }),
                bg: "blue.600",
                color: "white",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                    borderRadius: "md",
                    position: "absolute",
                    top: 2,
                    right: 2,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryPodcastIcon, {
                        color: "gray.400",
                        _hover: {
                            color: "blue.600"
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                mt: 0,
                mb: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        as: "time",
                        fontSize: "xs",
                        color: "gray.500",
                        textTransform: "uppercase",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IntlRelativeTime */.cv, {
                            value: story.lastPublishedAt || story.modifiedAt || story.createdAt || new Date(),
                            hideOlderThan: {
                                unit: "month",
                                value: 4
                            }
                        })
                    }),
                    translationLinkWrap && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        mb: "1px",
                        children: translationLinkWrap(story.slug)
                    })
                ]
            }),
            image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                alt: "story cover image",
                src: "https://imaginary-ssl.govlaunch.com/resize?quality=100&compression=0&width=326&height=163&url=".concat(image.url),
                width: "100%",
                maxHeight: "163px",
                minHeight: "163px",
                objectFit: "cover",
                borderRadius: "md",
                mb: 4
            }),
            !image && placeholderImageSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                alt: "story placeholder cover image",
                src: placeholderImageSrc,
                width: "100%",
                borderRadius: "md",
                mb: 4
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                fontSize: "xl",
                color: "blue.600",
                fontWeight: "bold",
                mt: 0,
                mb: 4,
                clamp: 2,
                title: story.title,
                children: story.title
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                fontSize: "sm",
                mt: 0,
                mb: 4,
                clamp: 2,
                children: story.introduction
            }),
            story.tags && story.tags.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tag */.Vp, {
                        maxWidth: "calc(100% - 24px)",
                        title: story.tags[0].name,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* TagText */.ys, {
                            children: story.tags[0].name
                        })
                    }),
                    story.tags.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                        as: "span",
                        fontSize: "sm",
                        marginLeft: 2,
                        fontWeight: "semibold",
                        color: "blue.800",
                        children: [
                            "+",
                            story.tags.length - 1
                        ]
                    })
                ]
            }),
            story.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                mt: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* GovernmentWithFlag */.zP, {
                    name: story.government.name,
                    logo: story.government.logo,
                    countryCode: story.government.city.country
                })
            })
        ]
    }));
});
StoryCard.displayName = "StoryCard";
/* harmony default export */ var src_StoryCard = (StoryCard);

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.8.1_psntm5zmlvip7zjgnrjqfe3wg4/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(43893);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(18648);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/FacebookIcon.js
var FacebookIcon = __webpack_require__(74239);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(5000);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/TwitterIcon.js
var TwitterIcon = __webpack_require__(22770);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(51299);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.0_react@17.0.2/node_modules/react-share/es/LinkedinIcon.js
var LinkedinIcon = __webpack_require__(80022);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryActions.tsx





function StoryActions(param) {
    var story = param.story, onToggleUpvote = param.onToggleUpvote, onToggleBookmark = param.onToggleBookmark, iconsArrangement = param.iconsArrangement;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "flex",
            justifyContent: iconsArrangement,
            paddingTop: 5
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookShareButton/* default */.Z, {
                    url: getCurrentUrl() || "/stories/".concat(story.slug),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                        alignItems: "center",
                        gridAutoFlow: "column",
                        gridColumnGap: 2,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FacebookIcon/* default */.Z, {
                            round: true,
                            size: 24
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterShareButton/* default */.Z, {
                    url: getCurrentUrl() || "/stories/".concat(story.slug),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                        alignItems: "center",
                        gridAutoFlow: "column",
                        gridColumnGap: 2,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TwitterIcon/* default */.Z, {
                            round: true,
                            size: 24
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinShareButton/* default */.Z, {
                    url: getCurrentUrl() || "/stories/".concat(story.slug),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                        alignItems: "center",
                        gridAutoFlow: "column",
                        gridColumnGap: 2,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkedinIcon/* default */.Z, {
                            round: true,
                            size: 24
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* UpvoteButton */.rL, {
                    upvoted: story.viewerDidUpvote,
                    onClick: function() {
                        return onToggleUpvote(story);
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* BookmarkButton */.eZ, {
                    bookmarked: story.viewerDidBookmark,
                    onClick: function() {
                        return onToggleBookmark(story);
                    }
                })
            })
        ]
    });
};
function getCurrentUrl() {
    if (false) {}
    return window.location.href;
}
var IconWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ewfubby0"
})({
    marginRight: 4,
    marginLeft: 4,
    display: "flex",
    alignItems: "center"
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryAuthor.tsx
var StoryAuthor = __webpack_require__(70384);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/ArrowIcons.tsx





function ArrowUpIcon(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "24",
        height: "12",
        viewBox: "0 0 24 12",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
            transform: "scale(1,-1) translate(0,-12) ",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M2 2.5L11.7436 9.55882L22 2.5",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    }));
}
function ArrowDownIcon(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "24",
        height: "12",
        viewBox: "0 0 24 12",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M2 2.5L11.7436 9.55882L22 2.5",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryCoauthors.tsx









function StoryCoauthors(_param) {
    var coauthors = _param.coauthors, renderLinkWrap = _param.renderLinkWrap, renderLinkWrapVendor = _param.renderLinkWrapVendor, _isMobile = _param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "coauthors",
        "renderLinkWrap",
        "renderLinkWrapVendor",
        "isMobile"
    ]);
    var ref = (0,react.useState)(false), showAll = ref[0], setShowAll = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    if (!coauthors || coauthors.length === 0) {
        return null;
    }
    var manyCoauthors = coauthors.length > 1;
    var showButton = manyCoauthors && isMobile;
    var sliceArray = !showAll && isMobile;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h3",
                color: "blue.500",
                fontWeight: "bold",
                fontSize: "18",
                mb: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Coauthors",
                    id: "8l11qK"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingLeft: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                    direction: "column",
                    alignItems: "flex-start"
                }, props), {
                    children: [
                        coauthors.slice(0, sliceArray ? 1 : coauthors.length).map(function(coauthor, index) {
                            var card = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    marginBottom: 10
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryAuthor/* StoryAuthorOneLineCard */.gy, {
                                    author: coauthor,
                                    cardTitle: intl.formatMessage({
                                        defaultMessage: "CO-AUTHOR",
                                        id: "Qo82cW"
                                    }),
                                    css: {
                                        backgroundColor: "white"
                                    },
                                    showDivider: manyCoauthors && index !== coauthors.length - 1,
                                    flexWrap: coauthor.__typename === "Company" ? "nowrap" : "wrap",
                                    fontSize: 16
                                }, coauthor.slug)
                            });
                            if (coauthor.__typename === "Company") {
                                return renderLinkWrapVendor ? renderLinkWrapVendor(coauthor, card) : card;
                            }
                            return renderLinkWrap ? renderLinkWrap(coauthor, card) : card;
                        }),
                        showButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            py: 3,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                variant: "secondary",
                                size: "sm",
                                onClick: function() {
                                    return setShowAll(!showAll);
                                },
                                "aria-label": showAll ? intl.formatMessage({
                                    defaultMessage: "Show Less",
                                    id: "PDd9N4"
                                }) : intl.formatMessage({
                                    defaultMessage: "Show More",
                                    id: "O8Z8t9"
                                }),
                                rightIcon: function(props) {
                                    return showAll ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowUpIcon, (0,src_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownIcon, (0,src_object_spread/* default */.Z)({}, props));
                                },
                                children: showAll ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Show Less",
                                    id: "PDd9N4"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Show More",
                                    id: "O8Z8t9"
                                })
                            })
                        })
                    ]
                }))
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/src/box/Box.tsx + 3 modules
var Box = __webpack_require__(49019);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/graphql/types.ts
var IAllSponsorshipsFilter;
(function(IAllSponsorshipsFilter) {
    IAllSponsorshipsFilter["All"] = "ALL";
    IAllSponsorshipsFilter["Archived"] = "ARCHIVED";
})(IAllSponsorshipsFilter || (IAllSponsorshipsFilter = {}));
var IAssistiveTechnology;
(function(IAssistiveTechnology) {
    IAssistiveTechnology["AlternativeInputDevice"] = "ALTERNATIVE_INPUT_DEVICE";
    IAssistiveTechnology["ScreenMagnification"] = "SCREEN_MAGNIFICATION";
    IAssistiveTechnology["ScreenReader"] = "SCREEN_READER";
    IAssistiveTechnology["SpeechInput"] = "SPEECH_INPUT";
    IAssistiveTechnology["TextReader"] = "TEXT_READER";
})(IAssistiveTechnology || (IAssistiveTechnology = {}));
var IBookmarkType;
(function(IBookmarkType) {
    IBookmarkType["Collection"] = "COLLECTION";
    IBookmarkType["Post"] = "POST";
    IBookmarkType["Product"] = "PRODUCT";
    IBookmarkType["Project"] = "PROJECT";
    IBookmarkType["Story"] = "STORY";
})(IBookmarkType || (IBookmarkType = {}));
var IBulkTaggingEntityType;
(function(IBulkTaggingEntityType) {
    IBulkTaggingEntityType["Project"] = "PROJECT";
})(IBulkTaggingEntityType || (IBulkTaggingEntityType = {}));
var IBulkTaggingModifyStrategy;
(function(IBulkTaggingModifyStrategy) {
    IBulkTaggingModifyStrategy["Add"] = "ADD";
    IBulkTaggingModifyStrategy["Overwrite"] = "OVERWRITE";
    IBulkTaggingModifyStrategy["Remove"] = "REMOVE";
})(IBulkTaggingModifyStrategy || (IBulkTaggingModifyStrategy = {}));
var IChargeStatus;
(function(IChargeStatus) {
    IChargeStatus["Failed"] = "FAILED";
    IChargeStatus["Pending"] = "PENDING";
    IChargeStatus["Succeeded"] = "SUCCEEDED";
})(IChargeStatus || (IChargeStatus = {}));
var ICollectionBookmarkStatus;
(function(ICollectionBookmarkStatus) {
    ICollectionBookmarkStatus["Saved"] = "SAVED";
    ICollectionBookmarkStatus["Unsaved"] = "UNSAVED";
})(ICollectionBookmarkStatus || (ICollectionBookmarkStatus = {}));
var ICollectionFeaturedStatus;
(function(ICollectionFeaturedStatus) {
    ICollectionFeaturedStatus["All"] = "ALL";
    ICollectionFeaturedStatus["FeaturedOnly"] = "FEATURED_ONLY";
    ICollectionFeaturedStatus["NotFeatured"] = "NOT_FEATURED";
})(ICollectionFeaturedStatus || (ICollectionFeaturedStatus = {}));
var ICollectionItemType;
(function(ICollectionItemType) {
    ICollectionItemType["Government"] = "GOVERNMENT";
    ICollectionItemType["Group"] = "GROUP";
    ICollectionItemType["Product"] = "PRODUCT";
    ICollectionItemType["Project"] = "PROJECT";
    ICollectionItemType["Story"] = "STORY";
})(ICollectionItemType || (ICollectionItemType = {}));
var ICollectionMethod;
(function(ICollectionMethod) {
    ICollectionMethod["ChargeAutomatically"] = "CHARGE_AUTOMATICALLY";
    ICollectionMethod["SendInvoice"] = "SEND_INVOICE";
})(ICollectionMethod || (ICollectionMethod = {}));
var ICollectionNewContentLastVisitAnchor;
(function(ICollectionNewContentLastVisitAnchor) {
    ICollectionNewContentLastVisitAnchor["LastTrackedViewerVisit"] = "LAST_TRACKED_VIEWER_VISIT";
    ICollectionNewContentLastVisitAnchor["LastVisitArgument"] = "LAST_VISIT_ARGUMENT";
})(ICollectionNewContentLastVisitAnchor || (ICollectionNewContentLastVisitAnchor = {}));
var ICollectionPackaging;
(function(ICollectionPackaging) {
    ICollectionPackaging[/** When a collection have more than two tags. */ "Bundle"] = "BUNDLE";
    ICollectionPackaging[/** When a collection is made of a single tag. */ "Single"] = "SINGLE";
})(ICollectionPackaging || (ICollectionPackaging = {}));
var ICollectionPublishedStatus;
(function(ICollectionPublishedStatus) {
    ICollectionPublishedStatus["Published"] = "PUBLISHED";
    ICollectionPublishedStatus["Unpublished"] = "UNPUBLISHED";
})(ICollectionPublishedStatus || (ICollectionPublishedStatus = {}));
var ICollectionSponsoring;
(function(ICollectionSponsoring) {
    ICollectionSponsoring["None"] = "NONE";
    ICollectionSponsoring["VendorCurated"] = "VENDOR_CURATED";
    ICollectionSponsoring["VendorSponsored"] = "VENDOR_SPONSORED";
})(ICollectionSponsoring || (ICollectionSponsoring = {}));
var ICollectionSponsoringPaymentSchedule;
(function(ICollectionSponsoringPaymentSchedule) {
    ICollectionSponsoringPaymentSchedule["LumpSum"] = "LUMP_SUM";
    ICollectionSponsoringPaymentSchedule["Monthly"] = "MONTHLY";
    ICollectionSponsoringPaymentSchedule["Quarterly"] = "QUARTERLY";
    ICollectionSponsoringPaymentSchedule["Yearly"] = "YEARLY";
})(ICollectionSponsoringPaymentSchedule || (ICollectionSponsoringPaymentSchedule = {}));
var ICollectionSponsoringSponsorshipLevel;
(function(ICollectionSponsoringSponsorshipLevel) {
    ICollectionSponsoringSponsorshipLevel["Product"] = "PRODUCT";
    ICollectionSponsoringSponsorshipLevel["Vendor"] = "VENDOR";
})(ICollectionSponsoringSponsorshipLevel || (ICollectionSponsoringSponsorshipLevel = {}));
var ICollectionSponsoringType;
(function(ICollectionSponsoringType) {
    ICollectionSponsoringType["Curated"] = "CURATED";
    ICollectionSponsoringType["Sponsored"] = "SPONSORED";
})(ICollectionSponsoringType || (ICollectionSponsoringType = {}));
var ICollectionStatus;
(function(ICollectionStatus) {
    ICollectionStatus["Active"] = "ACTIVE";
    ICollectionStatus["Archived"] = "ARCHIVED";
    ICollectionStatus["Inactive"] = "INACTIVE";
})(ICollectionStatus || (ICollectionStatus = {}));
var ICommentRepliesFilter;
(function(ICommentRepliesFilter) {
    ICommentRepliesFilter["All"] = "ALL";
    ICommentRepliesFilter["Viewer"] = "VIEWER";
})(ICommentRepliesFilter || (ICommentRepliesFilter = {}));
var ICommentTargetType;
(function(ICommentTargetType) {
    ICommentTargetType["Post"] = "POST";
    ICommentTargetType["Project"] = "PROJECT";
    ICommentTargetType["Report"] = "REPORT";
    ICommentTargetType["Story"] = "STORY";
})(ICommentTargetType || (ICommentTargetType = {}));
var IConnectTargetType;
(function(IConnectTargetType) {
    IConnectTargetType["Government"] = "GOVERNMENT";
    IConnectTargetType["Group"] = "GROUP";
    IConnectTargetType["User"] = "USER";
    IConnectTargetType["Vendor"] = "VENDOR";
})(IConnectTargetType || (IConnectTargetType = {}));
var IEntityType;
(function(IEntityType) {
    IEntityType["Company"] = "COMPANY";
    IEntityType["Government"] = "GOVERNMENT";
})(IEntityType || (IEntityType = {}));
var IFeaturedTargetType;
(function(IFeaturedTargetType) {
    IFeaturedTargetType["Product"] = "PRODUCT";
    IFeaturedTargetType["Report"] = "REPORT";
    IFeaturedTargetType["Story"] = "STORY";
})(IFeaturedTargetType || (IFeaturedTargetType = {}));
var IFollowType;
(function(IFollowType) {
    IFollowType["Government"] = "GOVERNMENT";
    IFollowType["User"] = "USER";
})(IFollowType || (IFollowType = {}));
var IGovernmentSearchScope;
(function(IGovernmentSearchScope) {
    IGovernmentSearchScope["Innovator"] = "INNOVATOR";
})(IGovernmentSearchScope || (IGovernmentSearchScope = {}));
var IGovernmentVerificationRequestSearchTarget;
(function(IGovernmentVerificationRequestSearchTarget) {
    IGovernmentVerificationRequestSearchTarget["Government"] = "GOVERNMENT";
    IGovernmentVerificationRequestSearchTarget["Group"] = "GROUP";
    IGovernmentVerificationRequestSearchTarget["Project"] = "PROJECT";
})(IGovernmentVerificationRequestSearchTarget || (IGovernmentVerificationRequestSearchTarget = {}));
var IGovernmentVerificationRequestSortBy;
(function(IGovernmentVerificationRequestSortBy) {
    IGovernmentVerificationRequestSortBy["Created"] = "CREATED";
    IGovernmentVerificationRequestSortBy["Government"] = "GOVERNMENT";
    IGovernmentVerificationRequestSortBy["Status"] = "STATUS";
})(IGovernmentVerificationRequestSortBy || (IGovernmentVerificationRequestSortBy = {}));
var IGovernmentVerificationRequestSortByDirection;
(function(IGovernmentVerificationRequestSortByDirection) {
    IGovernmentVerificationRequestSortByDirection["Ascending"] = "ASCENDING";
    IGovernmentVerificationRequestSortByDirection["Descending"] = "DESCENDING";
})(IGovernmentVerificationRequestSortByDirection || (IGovernmentVerificationRequestSortByDirection = {}));
var IGovernmentVerificationRequestStatus;
(function(IGovernmentVerificationRequestStatus) {
    IGovernmentVerificationRequestStatus["Cancelled"] = "CANCELLED";
    IGovernmentVerificationRequestStatus["Declined"] = "DECLINED";
    IGovernmentVerificationRequestStatus["Pending"] = "PENDING";
    IGovernmentVerificationRequestStatus["Verified"] = "VERIFIED";
})(IGovernmentVerificationRequestStatus || (IGovernmentVerificationRequestStatus = {}));
var IGovlaunchEnvironment;
(function(IGovlaunchEnvironment) {
    IGovlaunchEnvironment["Production"] = "PRODUCTION";
    IGovlaunchEnvironment["Qa"] = "QA";
})(IGovlaunchEnvironment || (IGovlaunchEnvironment = {}));
var IGroupKind;
(function(IGroupKind) {
    IGroupKind[/** Everything that doesn't fall in the above buckets will be "community" */ "Community"] = "COMMUNITY";
    IGroupKind[/** A group will be considered a Discussion if there's a Collection for it */ "Discussion"] = "DISCUSSION";
    IGroupKind[/** A group will be considered a Vendor if the owner is a Vendor */ "Vendor"] = "VENDOR";
})(IGroupKind || (IGroupKind = {}));
var IGroupRequestStatus;
(function(IGroupRequestStatus) {
    IGroupRequestStatus["Accepted"] = "ACCEPTED";
    IGroupRequestStatus["Canceled"] = "CANCELED";
    IGroupRequestStatus["Declined"] = "DECLINED";
    IGroupRequestStatus["Pending"] = "PENDING";
})(IGroupRequestStatus || (IGroupRequestStatus = {}));
var IGroupVisibility;
(function(IGroupVisibility) {
    IGroupVisibility["Private"] = "PRIVATE";
    IGroupVisibility["Public"] = "PUBLIC";
})(IGroupVisibility || (IGroupVisibility = {}));
var IGroupsFilter;
(function(IGroupsFilter) {
    IGroupsFilter["All"] = "ALL";
    IGroupsFilter["Archived"] = "ARCHIVED";
})(IGroupsFilter || (IGroupsFilter = {}));
var IImageSourceType;
(function(IImageSourceType) {
    IImageSourceType["Product"] = "PRODUCT";
    IImageSourceType["Story"] = "STORY";
})(IImageSourceType || (IImageSourceType = {}));
var IImagesQueryTab;
(function(IImagesQueryTab) {
    IImagesQueryTab["All"] = "ALL";
    IImagesQueryTab["Archived"] = "ARCHIVED";
    IImagesQueryTab["NoAlt"] = "NO_ALT";
    IImagesQueryTab["Placeholder"] = "PLACEHOLDER";
    IImagesQueryTab["WithAlt"] = "WITH_ALT";
})(IImagesQueryTab || (IImagesQueryTab = {}));
var IInvoiceStatus;
(function(IInvoiceStatus) {
    IInvoiceStatus["Draft"] = "DRAFT";
    IInvoiceStatus["Open"] = "OPEN";
    IInvoiceStatus["Paid"] = "PAID";
    IInvoiceStatus["Uncollectible"] = "UNCOLLECTIBLE";
    IInvoiceStatus["Void"] = "VOID";
})(IInvoiceStatus || (IInvoiceStatus = {}));
var ILandingContentType;
(function(ILandingContentType) {
    ILandingContentType["Image"] = "IMAGE";
    ILandingContentType["Podcast"] = "PODCAST";
    ILandingContentType["Video"] = "VIDEO";
})(ILandingContentType || (ILandingContentType = {}));
var types_IMediaType;
(function(IMediaType) {
    IMediaType["Image"] = "IMAGE";
    IMediaType["Video"] = "VIDEO";
    IMediaType["Youtube"] = "YOUTUBE";
})(types_IMediaType || (types_IMediaType = {}));
var INewsletterCampaignFrequency;
(function(INewsletterCampaignFrequency) {
    INewsletterCampaignFrequency["Biweekly"] = "BIWEEKLY";
    INewsletterCampaignFrequency["Monthly"] = "MONTHLY";
    INewsletterCampaignFrequency["Weekly"] = "WEEKLY";
})(INewsletterCampaignFrequency || (INewsletterCampaignFrequency = {}));
var INewsletterFrequency;
(function(INewsletterFrequency) {
    INewsletterFrequency["Biweekly"] = "BIWEEKLY";
    INewsletterFrequency["Monthly"] = "MONTHLY";
    INewsletterFrequency["Weekly"] = "WEEKLY";
})(INewsletterFrequency || (INewsletterFrequency = {}));
var IOutsideProductStatus;
(function(IOutsideProductStatus) {
    IOutsideProductStatus["Added"] = "ADDED";
    IOutsideProductStatus["Denied"] = "DENIED";
    IOutsideProductStatus["Ignored"] = "IGNORED";
    IOutsideProductStatus["Pending"] = "PENDING";
})(IOutsideProductStatus || (IOutsideProductStatus = {}));
var IPlanRecurrency;
(function(IPlanRecurrency) {
    IPlanRecurrency["Monthly"] = "MONTHLY";
    IPlanRecurrency["Yearly"] = "YEARLY";
})(IPlanRecurrency || (IPlanRecurrency = {}));
var IPlanTier;
(function(IPlanTier) {
    IPlanTier["Basic"] = "BASIC";
    IPlanTier["Disruptor"] = "DISRUPTOR";
    IPlanTier["Makers"] = "MAKERS";
    IPlanTier["Makerspro"] = "MAKERSPRO";
})(IPlanTier || (IPlanTier = {}));
var IPostAudience;
(function(IPostAudience) {
    IPostAudience["Community"] = "COMMUNITY";
    IPostAudience["Public"] = "PUBLIC";
})(IPostAudience || (IPostAudience = {}));
var IProcessStatusType;
(function(IProcessStatusType) {
    IProcessStatusType["AdditionalInformationRequired"] = "ADDITIONAL_INFORMATION_REQUIRED";
    IProcessStatusType["PendingVerification"] = "PENDING_VERIFICATION";
    IProcessStatusType["Required"] = "REQUIRED";
    IProcessStatusType["Verified"] = "VERIFIED";
})(IProcessStatusType || (IProcessStatusType = {}));
var IProductFilter;
(function(IProductFilter) {
    IProductFilter["All"] = "ALL";
    IProductFilter["Archived"] = "ARCHIVED";
    IProductFilter["Disruptors"] = "DISRUPTORS";
    IProductFilter["Regular"] = "REGULAR";
    IProductFilter["Submitted"] = "SUBMITTED";
    IProductFilter["Untagged"] = "UNTAGGED";
})(IProductFilter || (IProductFilter = {}));
var IProductSearchScope;
(function(IProductSearchScope) {
    IProductSearchScope["Basic"] = "BASIC";
    IProductSearchScope["Disruptor"] = "DISRUPTOR";
    IProductSearchScope["Makers"] = "MAKERS";
    IProductSearchScope["VendorIsDisruptor"] = "VENDOR_IS_DISRUPTOR";
})(IProductSearchScope || (IProductSearchScope = {}));
var IProductStackRequestStatus;
(function(IProductStackRequestStatus) {
    IProductStackRequestStatus["Accepted"] = "ACCEPTED";
    IProductStackRequestStatus["Canceled"] = "CANCELED";
    IProductStackRequestStatus["Declined"] = "DECLINED";
    IProductStackRequestStatus["Pending"] = "PENDING";
})(IProductStackRequestStatus || (IProductStackRequestStatus = {}));
var IProductStatus;
(function(IProductStatus) {
    IProductStatus["Approved"] = "APPROVED";
    IProductStatus["Submitted"] = "SUBMITTED";
})(IProductStatus || (IProductStatus = {}));
var IProductStatusFilter;
(function(IProductStatusFilter) {
    IProductStatusFilter["All"] = "ALL";
    IProductStatusFilter["Approved"] = "APPROVED";
    IProductStatusFilter["Submitted"] = "SUBMITTED";
})(IProductStatusFilter || (IProductStatusFilter = {}));
var IProfileCoverTarget;
(function(IProfileCoverTarget) {
    IProfileCoverTarget["Company"] = "COMPANY";
    IProfileCoverTarget["Government"] = "GOVERNMENT";
    IProfileCoverTarget["User"] = "USER";
})(IProfileCoverTarget || (IProfileCoverTarget = {}));
var IProjectAudience;
(function(IProjectAudience) {
    IProjectAudience["Community"] = "COMMUNITY";
    IProjectAudience["Private"] = "PRIVATE";
    IProjectAudience["Public"] = "PUBLIC";
})(IProjectAudience || (IProjectAudience = {}));
var IProjectType;
(function(IProjectType) {
    IProjectType["GovernmentProject"] = "GOVERNMENT_PROJECT";
    IProjectType["GroupProject"] = "GROUP_PROJECT";
    IProjectType["VendorProject"] = "VENDOR_PROJECT";
})(IProjectType || (IProjectType = {}));
var ISolutionStatus;
(function(ISolutionStatus) {
    ISolutionStatus["Approved"] = "APPROVED";
    ISolutionStatus["Archived"] = "ARCHIVED";
    ISolutionStatus["Submitted"] = "SUBMITTED";
})(ISolutionStatus || (ISolutionStatus = {}));
var ISortType;
(function(ISortType) {
    ISortType["Newest"] = "NEWEST";
    ISortType["Oldest"] = "OLDEST";
    ISortType["Top"] = "TOP";
})(ISortType || (ISortType = {}));
var IStoryAudience;
(function(IStoryAudience) {
    IStoryAudience["All"] = "ALL";
    IStoryAudience["Community"] = "COMMUNITY";
    IStoryAudience["Public"] = "PUBLIC";
})(IStoryAudience || (IStoryAudience = {}));
var IStoryFilter;
(function(IStoryFilter) {
    IStoryFilter["All"] = "ALL";
    IStoryFilter["Featured"] = "FEATURED";
})(IStoryFilter || (IStoryFilter = {}));
var IStoryStatus;
(function(IStoryStatus) {
    IStoryStatus["Approved"] = "APPROVED";
    IStoryStatus["Proposed"] = "PROPOSED";
    IStoryStatus["Published"] = "PUBLISHED";
    IStoryStatus["Unpublished"] = "UNPUBLISHED";
})(IStoryStatus || (IStoryStatus = {}));
var ISubscriptionStatus;
(function(ISubscriptionStatus) {
    ISubscriptionStatus["Active"] = "ACTIVE";
    ISubscriptionStatus["Cancelled"] = "CANCELLED";
})(ISubscriptionStatus || (ISubscriptionStatus = {}));
var ITagType;
(function(ITagType) {
    ITagType["Award"] = "AWARD";
    ITagType["Custom"] = "CUSTOM";
    ITagType["Department"] = "DEPARTMENT";
    ITagType["Product"] = "PRODUCT";
    ITagType["Project"] = "PROJECT";
    ITagType["Story"] = "STORY";
})(ITagType || (ITagType = {}));
var IUpvoteTargetType;
(function(IUpvoteTargetType) {
    IUpvoteTargetType["Comment"] = "COMMENT";
    IUpvoteTargetType["Post"] = "POST";
    IUpvoteTargetType["Product"] = "PRODUCT";
    IUpvoteTargetType["Project"] = "PROJECT";
    IUpvoteTargetType["Report"] = "REPORT";
    IUpvoteTargetType["Story"] = "STORY";
})(IUpvoteTargetType || (IUpvoteTargetType = {}));
var IUserRole;
(function(IUserRole) {
    IUserRole["Owner"] = "OWNER";
    IUserRole["User"] = "USER";
})(IUserRole || (IUserRole = {}));
var IUserSearchScope;
(function(IUserSearchScope) {
    IUserSearchScope["Citizen"] = "CITIZEN";
    IUserSearchScope["Community"] = "COMMUNITY";
    IUserSearchScope["Disruptor"] = "DISRUPTOR";
    IUserSearchScope["Government"] = "GOVERNMENT";
    IUserSearchScope["Innovator"] = "INNOVATOR";
    IUserSearchScope["Pending"] = "PENDING";
    IUserSearchScope["Vendor"] = "VENDOR";
})(IUserSearchScope || (IUserSearchScope = {}));
var IUserType;
(function(IUserType) {
    IUserType["Disruptor"] = "DISRUPTOR";
    IUserType["Innovator"] = "INNOVATOR";
    IUserType["Regular"] = "REGULAR";
})(IUserType || (IUserType = {}));
var IVendorSearchScope;
(function(IVendorSearchScope) {
    IVendorSearchScope["Disruptor"] = "DISRUPTOR";
})(IVendorSearchScope || (IVendorSearchScope = {}));
var IVerificationInput;
(function(IVerificationInput) {
    IVerificationInput["None"] = "NONE";
    IVerificationInput["Unverified"] = "UNVERIFIED";
    IVerificationInput["Verified"] = "VERIFIED";
})(IVerificationInput || (IVerificationInput = {}));
var IWorkPlaceType;
(function(IWorkPlaceType) {
    IWorkPlaceType["Government"] = "GOVERNMENT";
    IWorkPlaceType["None"] = "NONE";
    IWorkPlaceType["NonprofitOrNgo"] = "NONPROFIT_OR_NGO";
    IWorkPlaceType["Other"] = "OTHER";
    IWorkPlaceType["StateOrFederalAgency"] = "STATE_OR_FEDERAL_AGENCY";
    IWorkPlaceType["Vendor"] = "VENDOR";
})(IWorkPlaceType || (IWorkPlaceType = {}));

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryGallery.tsx








function StoryGallery(_param) {
    var story = _param.story, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "story"
    ]);
    var medias = story.medias;
    if (!medias || medias.length === 0) {
        return null;
    }
    var filteredMedias = medias.filter(function(param) {
        var type = param.type;
        return type === types_IMediaType.Youtube || type === types_IMediaType.Image;
    }).map(function(param) {
        var url = param.url, type = param.type, alt = param.alt;
        if (!url) {
            return null;
        }
        if (type === types_IMediaType.Youtube) {
            return {
                type: web/* IMediaType.Youtube */.BB.Youtube,
                url: url,
                alt: ""
            };
        }
        if (type === types_IMediaType.Image) {
            return {
                type: web/* IMediaType.Image */.BB.Image,
                url: url,
                alt: alt
            };
        }
        return null;
    }).filter(notUndefinedOrNull);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.ZP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        css: {
            borderTop: "1px solid",
            borderBottom: "1px solid",
            borderColor: web/* palette.gray.100 */.DG.gray[100],
            paddingTop: 10,
            paddingBottom: 10,
            marginBottom: 30
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* GalleryState */.e9, {
            medias: filteredMedias,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* GallerySelectedMedia */.kU, {
                    storyTitle: story.title
                }),
                filteredMedias.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* GalleryThumbnails */.EZ, {
                    storyTitle: story.title
                })
            ]
        })
    }));
};
function notUndefinedOrNull(value) {
    return value !== null && value !== undefined;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryHighlights.tsx







function StoryHighlights(_param) {
    var highlights = _param.highlights, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "highlights"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                py: 3,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                    as: "h2",
                    color: "gray.900",
                    css: {
                        fontSize: 32,
                        fontWeight: 600
                    },
                    mb: 1,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Highlights",
                        id: "KGmQjH"
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                css: {
                    padding: "16px 16px 16px 0px"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ul", {
                    css: {
                        listStyle: "none",
                        margin: 0,
                        padding: 0,
                        display: "grid",
                        gridRowGap: 4
                    },
                    children: highlights.map(function(highlight, index) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
                            css: {
                                display: "flex",
                                alignItems: "center",
                                paddingBottom: 5
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                    mr: 1,
                                    mt: 2,
                                    display: "inline-block",
                                    pr: 4,
                                    width: "13px",
                                    mb: "auto",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                        width: "6px",
                                        height: "6px",
                                        bg: "teal.600",
                                        borderRadius: "full"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    css: {
                                        wordBreak: "break-word",
                                        color: web/* palette.black */.DG.black,
                                        fontSize: 20,
                                        fontWeight: 400,
                                        display: "inline-block"
                                    },
                                    children: highlight
                                })
                            ]
                        }, index);
                    })
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryAwards.tsx




function StoryAwards(param) {
    var story = param.story;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h3",
                color: "blue.500",
                fontWeight: "bold",
                fontSize: "18",
                mb: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Awards",
                    id: "FqvBgl"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingLeft: 10
                },
                children: story.awards.map(function(award) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tag */.Vp, {
                        variant: "rounded",
                        maxWidth: "250px",
                        mr: 2,
                        mb: 2,
                        title: award.name,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* TagText */.ys, {
                            children: award.name
                        })
                    }, award._id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryHeader.tsx







function StoryHeader(_param) {
    var story = _param.story, headerRef = _param.headerRef, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "story",
        "headerRef"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.ZP, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        id: "test",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                css: {
                    fontSize: "40px !important",
                    fontWeight: 700,
                    color: "#086BE5"
                },
                ref: headerRef,
                children: story.title
            }),
            story.introduction && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                mt: 2,
                css: {
                    fontSize: "20px !important",
                    fontWeight: 400
                },
                children: story.introduction
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryNewsworthyItem.tsx






function StoryNewsworthyItem(_param) {
    var newsworthy = _param.newsworthy, isMobile = _param.isMobile, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "newsworthy",
        "isMobile"
    ]);
    var ref;
    var faviconUrl = newsworthy.favicon ? (0,web/* getSecureRedirect */.Ej)(newsworthy.favicon, "outside-govlaunch") : undefined;
    var shouldDisplayImage = (0,web/* useHasImageLoaded */.L2)({
        src: faviconUrl
    });
    var title = newsworthy.title || newsworthy.siteName || new URL(newsworthy.url || "").hostname;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        title: title,
        "aria-label": title,
        external: "outside-govlaunch",
        href: newsworthy.url,
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        flex: "1 1 auto",
        overflow: "hidden",
        minHeight: isMobile ? "95px" : "131px",
        py: isMobile ? 0 : 6,
        paddingLeft: 0,
        paddingRight: 8,
        _hover: {
            textDecoration: "none",
            boxShadow: "md"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                color: "blue.600",
                isTruncated: true,
                fontWeight: "semibold",
                fontSize: "md",
                title: title,
                width: "100%",
                children: title
            }),
            newsworthy.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                color: "black",
                clamp: 2,
                fontSize: "sm",
                title: newsworthy.description,
                width: "100%",
                children: newsworthy.description.trim()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                align: "center",
                mt: 3,
                children: [
                    newsworthy.favicon && shouldDisplayImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                        width: 6,
                        height: 6,
                        src: newsworthy.favicon,
                        external: ((ref = newsworthy.favicon) === null || ref === void 0 ? void 0 : ref.startsWith("https")) ? "govlaunch" : "outside-redirect",
                        alt: "link favicon",
                        mr: 2
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                        color: "black",
                        isTruncated: true,
                        fontSize: "sm",
                        mb: 0,
                        children: title
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryNewsworthy.tsx








function StoryNewsworthy(_param) {
    var story = _param.story, _stacked = _param.stacked, stacked = _stacked === void 0 ? false : _stacked, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "story",
        "stacked"
    ]);
    if (!story.newsworthy || story.newsworthy.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        display: "grid"
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h2",
                color: "gray.900",
                css: {
                    fontSize: 32,
                    fontWeight: 600
                },
                mb: 1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Newsworthy",
                    id: "JhItYg"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* NewsworthyScrollbarsContainer */.pT, {
                mt: 1,
                stacked: stacked,
                children: story.newsworthy.map(function(newsworthy) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryNewsworthyItem, {
                        isMobile: stacked,
                        newsworthy: {
                            url: newsworthy.url || "",
                            description: newsworthy.description,
                            favicon: newsworthy.favicon,
                            title: newsworthy.title || "",
                            siteName: newsworthy.siteName || ""
                        }
                    }, newsworthy.url || Math.random().toString(16));
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryRelatedStories.tsx









function StoryRelatedStories(_param) {
    var title = _param.title, relatedStories = _param.relatedStories, renderLinkWrap = _param.renderLinkWrap, placeholderImageSrc = _param.placeholderImageSrc, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "title",
        "relatedStories",
        "renderLinkWrap",
        "placeholderImageSrc"
    ]);
    var intl = (0,useIntl/* default */.Z)();
    var ref = useShowMore({
        items: relatedStories,
        initialCount: 2
    }), items = ref.items, showingMore = ref.showingMore, toggle = ref.toggle;
    var cardTitle = title || intl.formatMessage({
        defaultMessage: "Related Stories",
        id: "nuwuqz"
    });
    if (!items || items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Card */.Zb, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* CardHeader */.Ol, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardIcon */._K, {
                        viewBox: "0 0 24 24",
                        width: "24px",
                        height: "24px",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RelatedStoriesIcon, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardTitle */.ll, {
                        as: "h2",
                        children: cardTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CardBody */.eW, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Stack */.Kq, {
                    direction: "column",
                    mt: 3,
                    shouldWrapChildren: true,
                    children: [
                        items.map(function(relatedStory, index) {
                            var storyCoverImage = (relatedStory.medias || []).find(function(param) {
                                var type = param.type;
                                return type === types_IMediaType.Image;
                            });
                            var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Anchor */.ee, {
                                borderTop: index === 0 ? null : "1px",
                                d: "block",
                                borderColor: "gray.100",
                                pt: index === 0 ? 0 : 6,
                                mt: index === 0 ? 0 : 4,
                                children: [
                                    storyCoverImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                                        alt: "story cover image",
                                        src: "https://imaginary-ssl.govlaunch.com/resize?quality=100&compression=0&width=326&height=163&url=".concat(storyCoverImage.url),
                                        width: "100%",
                                        maxHeight: "132px",
                                        minHeight: "132px",
                                        objectFit: "cover",
                                        borderRadius: "md",
                                        mx: "auto",
                                        mb: 4
                                    }),
                                    !storyCoverImage && placeholderImageSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                                        alt: "story cover placeholder image",
                                        src: placeholderImageSrc,
                                        width: "100%",
                                        borderRadius: "md",
                                        htmlWidth: "100%",
                                        htmlHeight: "120px",
                                        mx: "auto",
                                        mb: 4
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        fontSize: "xs",
                                        color: "gray.500",
                                        mt: 4,
                                        mb: 2,
                                        textDecoration: "none !important",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* IntlRelativeTime */.cv, {
                                            value: relatedStory.lastPublishedAt || relatedStory.modifiedAt || relatedStory.createdAt || new Date(),
                                            hideOlderThan: {
                                                unit: "month",
                                                value: 4
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        as: "h4",
                                        color: "blue.600",
                                        fontWeight: "bold",
                                        fontSize: "xl",
                                        clamp: 2,
                                        title: relatedStory.title,
                                        children: relatedStory.title
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        color: "gray.900",
                                        fontSize: "sm",
                                        clamp: 2,
                                        m: 0,
                                        children: relatedStory.introduction
                                    })
                                ]
                            }, relatedStory._id);
                            return renderLinkWrap ? renderLinkWrap(relatedStory, children) : children;
                        }),
                        relatedStories.length > 2 && !showingMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                            justify: "center",
                            mt: 4,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                variant: "secondary",
                                size: "sm",
                                onClick: toggle,
                                rightIcon: function(props) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownIcon, (0,src_object_spread/* default */.Z)({}, props));
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Show more",
                                    id: "aWpBzj"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
function RelatedStoriesIcon() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M23 0L12 2L1 0C0.4 0 0 0.4 0 1V21C0 21.6 0.4 22 1 22L12 24L23 22C23.6 22 24 21.6 24 21V1C24 0.4 23.6 0 23 0ZM11 21.8L2 20V18L11 20V21.8ZM11 19L2 17V2L11 3.8V19ZM22 20L13 21.8V20L22 18V20ZM22 17L13 19V3.8L22 2V17Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 14L15 15V16L20 15V14Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 11L15 12V13L20 12V11Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 8L15 9V10L20 9V8Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M20 5L15 6V7L20 6V5Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M9.00024 15L4.00024 14V15L9.00024 16V15Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M9.00024 12L4.00024 11V12L9.00024 13V12Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M9.00024 9L4.00024 8V9L9.00024 10V9Z",
                fill: "#086BE5"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M9.00024 6L4.00024 5V6L9.00024 7V6Z",
                fill: "#086BE5"
            })
        ]
    });
}
function useShowMore(param) {
    var items = param.items, _initialCount = param.initialCount, initialCount = _initialCount === void 0 ? 2 : _initialCount;
    var ref = (0,react.useState)(false), isShowingMore = ref[0], setShowMore = ref[1];
    if (isShowingMore) {
        return {
            items: items,
            showingMore: true,
            toggle: function() {
                return setShowMore(false);
            }
        };
    }
    return {
        items: items.slice(0, initialCount),
        showingMore: false,
        toggle: function() {
            return setShowMore(true);
        }
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryRelatedStoriesSmall.tsx








function StoryRelatedStoriesSmall(param) {
    var relatedStories = param.relatedStories, renderLinkWrap = param.renderLinkWrap, placeholderImageSrc = param.placeholderImageSrc, renderTagLinkWrap = param.renderTagLinkWrap, renderAuthorLinkWrap = param.renderAuthorLinkWrap;
    var ref = StoryRelatedStoriesSmall_useShowMore({
        items: relatedStories,
        initialCount: 2
    }), items = ref.items, showingMore = ref.showingMore, toggle = ref.toggle;
    if (!items || items.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h2",
                color: "gray.900",
                fontWeight: "bold",
                fontSize: "2xl",
                mb: 1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Related Stories",
                    id: "nuwuqz"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingLeft: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Stack */.Kq, {
                    direction: "column",
                    mt: 3,
                    shouldWrapChildren: true,
                    children: [
                        items.map(function(relatedStory, index) {
                            var storyCoverImage = (relatedStory.medias || []).find(function(param) {
                                var type = param.type;
                                return type === types_IMediaType.Image;
                            });
                            var authorChildren = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryAuthor/* StoryAuthorOneLineCard */.gy, {
                                author: relatedStory.author,
                                fontSize: 14,
                                flexWrap: "wrap"
                            });
                            var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    borderTop: index === 0 ? "none" : "1px solid",
                                    borderColor: web/* palette.gray.100 */.DG.gray[100],
                                    paddingTop: 10
                                },
                                children: [
                                    renderAuthorLinkWrap ? renderAuthorLinkWrap(relatedStory, authorChildren) : authorChildren,
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
                                        d: "block",
                                        borderColor: "gray.100",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                display: "flex",
                                                marginBottom: 15,
                                                marginTop: 15
                                            },
                                            children: [
                                                storyCoverImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                                                    alt: "story cover image",
                                                    src: "https://imaginary-ssl.govlaunch.com/resize?quality=100&compression=0&width=326&height=163&url=".concat(storyCoverImage.url),
                                                    borderRadius: "md",
                                                    width: 50,
                                                    height: 50,
                                                    mr: 3
                                                }),
                                                !storyCoverImage && placeholderImageSrc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Image */.Ee, {
                                                    alt: "story cover placeholder image",
                                                    src: placeholderImageSrc,
                                                    maxWidth: 80,
                                                    mr: 4
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                    as: "h4",
                                                    color: "blue.600",
                                                    css: {
                                                        fontSize: 17,
                                                        fontWeight: 700
                                                    },
                                                    clamp: 2,
                                                    title: relatedStory.title,
                                                    children: relatedStory.title
                                                })
                                            ]
                                        })
                                    }, relatedStory._id),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: relatedStory.tags.map(function(tag) {
                                            var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tag */.Vp, {
                                                mr: 2,
                                                mb: 2,
                                                color: "black",
                                                title: tag.name,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* TagText */.ys, {
                                                    children: tag.name
                                                })
                                            }, tag._id);
                                            return renderTagLinkWrap ? renderTagLinkWrap(tag, children) : children;
                                        })
                                    })
                                ]
                            });
                            return renderLinkWrap ? renderLinkWrap(relatedStory, children) : children;
                        }),
                        relatedStories.length > 2 && !showingMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                            justify: "center",
                            mt: 4,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                                variant: "secondary",
                                size: "sm",
                                onClick: toggle,
                                rightIcon: function(props) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArrowDownIcon, (0,src_object_spread/* default */.Z)({}, props));
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Show more",
                                    id: "aWpBzj"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
function StoryRelatedStoriesSmall_useShowMore(param) {
    var items = param.items, _initialCount = param.initialCount, initialCount = _initialCount === void 0 ? 2 : _initialCount;
    var ref = (0,react.useState)(false), isShowingMore = ref[0], setShowMore = ref[1];
    if (isShowingMore) {
        return {
            items: items,
            showingMore: true,
            toggle: function() {
                return setShowMore(false);
            }
        };
    }
    return {
        items: items.slice(0, initialCount),
        showingMore: false,
        toggle: function() {
            return setShowMore(true);
        }
    };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StorySummary.tsx







function StorySummary(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(Card, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx(CardHeader, {
                justifyContent: "flex-start",
                px: 8,
                children: /*#__PURE__*/ _jsx(CardTitle, {
                    color: "black",
                    as: "h2",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        defaultMessage: "Summary",
                        id: "RrCui3"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(CardBody, {
                children: children
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryProducts.tsx




function StoryProducts(param) {
    var products = param.products, renderLinkWrap = param.renderLinkWrap;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h3",
                color: "blue.500",
                fontWeight: "bold",
                fontSize: "18",
                mb: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Products",
                    id: "7NFfmz"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingLeft: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                    columns: 1,
                    spacing: 2,
                    children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                        var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                    src: product.logo,
                                    name: product.name,
                                    size: "sm",
                                    variant: product.isDisruptor ? "disruptor" : null,
                                    mr: 4
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                    label: product.name,
                                    bg: "blue.600",
                                    color: "white",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                        isTruncated: true,
                                        fontSize: "md",
                                        children: product.name
                                    })
                                }, product._id)
                            ]
                        });
                        return renderLinkWrap ? renderLinkWrap(product, children) : children;
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryCollaborators.tsx




function StoryCollaborators(param) {
    var collaborators = param.collaborators, renderLinkWrap = param.renderLinkWrap;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h3",
                color: "blue.500",
                fontWeight: "bold",
                fontSize: "18",
                mb: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Collaborators",
                    id: "9Jstnt"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingLeft: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column"
                    },
                    children: collaborators.map(function(collaborator) {
                        var collaboratorTitle = collaborator.isSiteAdmin || collaborator.isLimitedSiteAdmin ? "Executive Producer" : collaborator.__typename !== "PendingUser" ? collaborator.title : collaborator.jobTitle;
                        var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                marginBottom: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        marginBottom: 4
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                        src: collaborator.avatar,
                                        name: collaborator.fullName || collaborator.firstName,
                                        size: "sm",
                                        marginRight: 3
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        color: "gray.700",
                                        marginLeft: 10,
                                        fontSize: 16,
                                        fontWeight: 600
                                    },
                                    children: collaborator.fullName || collaborator.firstName
                                }),
                                typeof collaboratorTitle !== "undefined" && collaboratorTitle && collaboratorTitle.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        marginRight: 5
                                    },
                                    children: ", "
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        color: "gray.600",
                                        fontSize: 14,
                                        fontWeight: 400
                                    },
                                    children: collaboratorTitle
                                })
                            ]
                        });
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                            shouldWrapChildren: true,
                            label: collaborator.fullName || collaborator.firstName || intl.formatMessage({
                                defaultMessage: "Member of Govlaunch",
                                id: "hT39cQ"
                            }),
                            bg: "blue.600",
                            color: "white",
                            children: renderLinkWrap ? renderLinkWrap(collaborator, children) : children
                        }, collaborator._id);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryResources.tsx




function StoryResources(param) {
    var resources = param.resources;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h3",
                color: "blue.500",
                fontWeight: "bold",
                fontSize: "18",
                mb: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Resources",
                    id: "c/KktL"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingLeft: 10
                },
                children: resources && resources.map(function(resource, index) {
                    if (resource.__typename === "LinkResource") {
                        return(// ok to disable eslint for react/no-array-index-key because the user can not change the list from the UI
                        // eslint-disable-next-line
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                marginBottom: 8
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* LinkResource */.iI, {
                                href: resource.url || "#",
                                children: resource.title
                            })
                        }, "".concat(resource.title, "_").concat(index)));
                    }
                    if (resource.__typename === "DownloadResource") {
                        return(// eslint-disable-next-line
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                marginBottom: 8
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* DownloadResource */.Jo, {
                                href: resource.url || "#",
                                children: resource.title
                            })
                        }, "".concat(resource.title, "_").concat(index)));
                    }
                    return null;
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/StoryGovernments.tsx




function StoryGovernments(param) {
    var locations = param.locations, renderLinkWrap = param.renderLinkWrap;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Heading */.E2, {
                as: "h3",
                color: "blue.500",
                fontWeight: "bold",
                fontSize: "18",
                mb: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Governments",
                    id: "qnQX9U"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    paddingLeft: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
                    wrap: "nowrap",
                    mt: 3,
                    direction: "column",
                    children: locations && locations.map(function(location) {
                        var children = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                            mr: 3,
                            mb: 2,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* GovernmentWithFlag */.zP, {
                                countryCode: location.city.country,
                                name: location.name,
                                logo: location.logo
                            })
                        }, location._id);
                        return renderLinkWrap ? renderLinkWrap(location, children) : children;
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/components/index.tsx

















// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/fragments/RelatedStoriesFieldsFragment.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment RelatedStoriesFields on Story {\n    _id\n    title\n    slug\n    createdAt\n    modifiedAt\n    lastPublishedAt\n    introduction\n    medias {\n      url\n      type\n    }\n    author {\n      ... on VendorUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        title\n        avatar\n      }\n      ... on GovernmentUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        title\n        avatar\n      }\n      ... on PendingUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        avatar\n      }\n    }\n    tags {\n      _id\n      name\n      slug\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var RelatedStoriesFieldsFragment = ((0,lib/* default */.ZP)(_templateObject()));

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/fragments/StoryCardFieldsFragment.ts

function StoryCardFieldsFragment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment StoryCardFields on Story {\n    _id\n    title\n    slug\n    introduction\n    createdAt\n    modifiedAt\n    lastPublishedAt\n    hasPodcast\n    medias {\n      url\n      type\n    }\n    government {\n      _id\n      name\n      logo\n      city {\n        _id\n        country\n      }\n    }\n    tags {\n      _id\n      name\n      slug\n    }\n  }\n"
    ]);
    StoryCardFieldsFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StoryCardFieldsFragment = (0,lib/* default */.ZP)(StoryCardFieldsFragment_templateObject());
/* harmony default export */ var fragments_StoryCardFieldsFragment = (StoryCardFieldsFragment);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/fragments/StoryFieldsFragment.ts

function StoryFieldsFragment_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment StoryFields on Story {\n    _id\n    slug\n    title\n    introduction\n    body\n    highlights\n    createdAt\n    modifiedAt\n    verticalCover\n    viewerCanRead\n    commentsCount\n    author {\n      ... on VendorUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        title\n        avatar\n      }\n      ... on GovernmentUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        title\n        avatar\n      }\n      ... on PendingUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        avatar\n      }\n    }\n\n    coauthors {\n      ... on VendorUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        title\n        avatar\n      }\n      ... on GovernmentUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        title\n        avatar\n      }\n      ... on PendingUser {\n        _id\n        firstName\n        slug\n        isSiteAdmin\n        isLimitedSiteAdmin\n        fullName\n        jobTitle\n        avatar\n      }\n    }\n\n    vendorCoauthors {\n      _id\n      name\n      logo\n      slug\n    }\n\n    products {\n      _id\n      name\n      slug\n      isDisruptor\n      logo\n    }\n    collaborators {\n      ... on PendingUser {\n        _id\n        fullName\n        firstName\n        avatar\n        slug\n        jobTitle\n        isSiteAdmin\n        isLimitedSiteAdmin\n      }\n      ... on GovernmentUser {\n        _id\n        fullName\n        firstName\n        avatar\n        slug\n        jobTitle\n        title\n        isSiteAdmin\n        isLimitedSiteAdmin\n      }\n      ... on VendorUser {\n        _id\n        fullName\n        firstName\n        avatar\n        slug\n        jobTitle\n        title\n        isSiteAdmin\n        isLimitedSiteAdmin\n      }\n    }\n    tags {\n      _id\n      name\n      slug\n    }\n    awards {\n      _id\n      name\n    }\n    government {\n      _id\n      name\n      logo\n      slug\n      city {\n        _id\n        country\n      }\n    }\n    locations {\n      _id\n      name\n      logo\n      slug\n      city {\n        _id\n        country\n      }\n    }\n    viewerDidUpvote\n    viewerDidBookmark\n    medias {\n      url\n      type\n      alt\n    }\n    resources {\n      ... on LinkResource {\n        title\n        url\n        addedAt\n      }\n      ... on DownloadResource {\n        title\n        url\n        filename\n        addedAt\n      }\n      ... on TextResource {\n        title\n        body\n        addedAt\n      }\n    }\n    newsworthy {\n      url\n      title\n      description\n      favicon\n      siteName\n    }\n    relatedStories {\n      ...RelatedStoriesFields\n    }\n  }\n\n  ",
        "\n"
    ]);
    StoryFieldsFragment_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StoryFieldsFragment = (0,lib/* default */.ZP)(StoryFieldsFragment_templateObject(), RelatedStoriesFieldsFragment);
/* harmony default export */ var fragments_StoryFieldsFragment = (StoryFieldsFragment);

;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/src/fragments/index.ts




;// CONCATENATED MODULE: ./node_modules/.pnpm/@govlaunch+story@2.26.38_vwg5avgammb3tgf4ng7alozbti_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/story/index.ts






/***/ }),

/***/ 70384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z8": function() { return /* binding */ constructCoauthors; },
/* harmony export */   "ZP": function() { return /* binding */ StoryAuthor; },
/* harmony export */   "gy": function() { return /* binding */ StoryAuthorOneLineCard; }
/* harmony export */ });
/* unused harmony exports parseTCoauthorFromCoauthor, parseTCoauthorFromVendorCoauthor, StoryAuthorCard */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94614);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49980);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);







function StoryAuthor(_param) {
    var story = _param.story, cardTitle = _param.cardTitle, renderLinkWrap = _param.renderLinkWrap, _isSmall = _param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "story",
        "cardTitle",
        "renderLinkWrap",
        "isSmall"
    ]);
    if (!story.author) {
        return null;
    }
    var children = isSmall ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StoryAuthorOneLineCard, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        author: story.author
    }, props), {
        fontSize: 18,
        flexWrap: "wrap"
    })) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StoryAuthorCard, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        author: story.author,
        cardTitle: cardTitle
    }, props));
    return renderLinkWrap ? renderLinkWrap(story, children) : children;
};
function constructCoauthors(coauthors, vendorCoauthors) {
    var nonNullableCoauthors = coauthors || [];
    var nonNullableVendorCoauthors = vendorCoauthors || [];
    var parsedCoauthor = nonNullableCoauthors.map(function(coauthor) {
        return parseTCoauthorFromCoauthor(coauthor);
    });
    var parsedVendorCoauthors = nonNullableVendorCoauthors.map(function(vendorCoauthor) {
        return parseTCoauthorFromVendorCoauthor(vendorCoauthor);
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(parsedVendorCoauthors).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(parsedCoauthor)).filter(Boolean);
}
function parseTCoauthorFromCoauthor(coauthor) {
    if (coauthor.__typename === "VendorUser" || coauthor.__typename === "GovernmentUser") {
        return {
            __typename: coauthor.__typename,
            _id: coauthor._id,
            firstName: coauthor.firstName,
            slug: coauthor.slug,
            isSiteAdmin: coauthor.isSiteAdmin,
            isLimitedSiteAdmin: coauthor.isLimitedSiteAdmin,
            fullName: coauthor.fullName,
            jobTitle: coauthor.fullName,
            title: coauthor.title,
            avatar: coauthor.avatar,
            logo: coauthor.avatar,
            name: coauthor.fullName
        };
    }
    return {
        __typename: coauthor.__typename,
        _id: coauthor._id,
        firstName: coauthor.firstName,
        slug: coauthor.slug,
        isSiteAdmin: coauthor.isSiteAdmin,
        isLimitedSiteAdmin: coauthor.isLimitedSiteAdmin,
        fullName: coauthor.fullName,
        jobTitle: coauthor.fullName,
        title: null,
        avatar: coauthor.avatar,
        logo: coauthor.avatar,
        name: coauthor.fullName
    };
}
function parseTCoauthorFromVendorCoauthor(vendorCoauthor) {
    return {
        __typename: vendorCoauthor.__typename,
        _id: vendorCoauthor._id,
        firstName: vendorCoauthor.name,
        slug: vendorCoauthor.slug,
        isSiteAdmin: null,
        isLimitedSiteAdmin: null,
        fullName: vendorCoauthor.name,
        jobTitle: null,
        title: null,
        avatar: vendorCoauthor.logo,
        logo: vendorCoauthor.logo,
        name: vendorCoauthor.name
    };
}
function StoryAuthorCard(_param) {
    var author = _param.author, _cardTitle = _param.cardTitle, cardTitle = _cardTitle === void 0 ? "AUTHOR" : _cardTitle, _showDivider = _param.showDivider, showDivider = _showDivider === void 0 ? false : _showDivider, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "author",
        "cardTitle",
        "showDivider"
    ]);
    var authorAvatar = author.isSiteAdmin || author.isLimitedSiteAdmin ? "https://cdn.filestackcontent.com/jGYfT4X8QyGteXUmbjgM" : author.avatar;
    var authorName = author.isSiteAdmin || author.isLimitedSiteAdmin ? "Lindsay Pica-Alfano" : author.fullName || author.firstName;
    // eslint-disable-next-line
    var authorTitle = author.isSiteAdmin || author.isLimitedSiteAdmin ? "Executive Producer" : author.__typename !== "PendingUser" ? author.title : author.jobTitle;
    var card = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        bg: "teal.200",
        p: 8,
        pb: 4,
        direction: "column",
        alignItems: "center"
    }, getDividerProps(showDivider), props), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Avatar */ .qE, {
                size: "xl",
                src: authorAvatar,
                name: authorName,
                borderColor: "blue.600",
                border: "2px"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                color: "gray.700",
                mt: 4,
                mb: 3,
                fontSize: "md",
                children: authorName
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                color: "gray.600",
                fontSize: "sm",
                m: 0,
                textAlign: "center",
                children: authorTitle
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
                color: "blue.700",
                mt: 2,
                mb: 0,
                fontSize: "sm",
                textTransform: "uppercase",
                css: {
                    textOverflow: "ellipsis"
                },
                children: cardTitle
            })
        ]
    }));
    return card;
}
function StoryAuthorOneLineCard(param) {
    var author = param.author, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? 18 : _fontSize, _flexWrap = param.flexWrap, flexWrap = _flexWrap === void 0 ? "wrap" : _flexWrap;
    var authorAvatar = author.isSiteAdmin || author.isLimitedSiteAdmin ? "https://cdn.filestackcontent.com/jGYfT4X8QyGteXUmbjgM" : author.avatar;
    var authorName = author.isSiteAdmin || author.isLimitedSiteAdmin ? "Lindsay Pica-Alfano" : author.fullName || author.firstName;
    // eslint-disable-next-line
    var authorTitle = author.isSiteAdmin || author.isLimitedSiteAdmin ? "Executive Producer" : author.__typename !== "PendingUser" ? author.title : author.jobTitle;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("div", {
        css: {
            display: "flex",
            flexDirection: "row",
            flexWrap: flexWrap,
            alignItems: "center",
            justifyContent: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
                css: {
                    marginBottom: 4
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .Avatar */ .qE, {
                    size: "sm",
                    src: authorAvatar,
                    name: authorName,
                    borderColor: "blue.600",
                    border: "2px"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                css: {
                    color: "gray.700",
                    marginLeft: 10,
                    fontSize: fontSize,
                    fontWeight: 600
                },
                children: authorName
            }),
            typeof authorTitle !== "undefined" && authorTitle && authorTitle.length > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                css: {
                    marginRight: 5
                },
                children: ", "
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("span", {
                css: {
                    color: "gray.600",
                    fontSize: fontSize - 2,
                    fontWeight: 400
                },
                children: authorTitle
            })
        ]
    });
}
function getDividerProps(showDivider) {
    if (showDivider) {
        return {
            borderBottom: "1px",
            borderColor: "gray.100"
        };
    }
    return null;
}


/***/ })

}]);